import { api } from '../../services/HttpService'

export const extranetUsersQueryKeyFactory = {
  getCurrentUser: (...params: (undefined | any)[]) => ['__getCurrentUser', ...params],
}

export const extranetCurrentUserQuery = (...params: (undefined | any)[]) => ({
  queryFn: async () => await api.users.getLoggedInUser(),
  queryKey: extranetUsersQueryKeyFactory.getCurrentUser(params),
})
